import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_domain_input = _resolveComponent("ontos-domain-input")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ontos_form_dialog = _resolveComponent("ontos-form-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_form_dialog, _mergeProps(_ctx.heading, {
    "max-width": "800px",
    saving: _ctx.saving,
    "save-disabled": _ctx.edit.unchanged,
    "full-page-route": _ctx.fullPageRoute,
    dirty: _ctx.edit.dirty,
    onSave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
    onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closed')))
  }), {
    default: _withCtx(() => [
      _createVNode(_component_v_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_ontos_domain_input, {
            ref: "input",
            value: _ctx.draft,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.draft = $event)),
            domains: _ctx.workspace.domains,
            "fixed-alias": !_ctx.isCreating,
            "start-with-auto-alias": _ctx.isCreating
          }, null, 8, ["value", "domains", "fixed-alias", "start-with-auto-alias"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["saving", "save-disabled", "full-page-route", "dirty"]))
}